<app-driver-list [ngClass]="!mapNotExpanded ? 'invisible height-zero' : ''"></app-driver-list>
<div class="map-navbar d-flex justify-content-between pt-2 pb-2">
    <button class="btn btn-primary" (click)="mapNotExpanded = !mapNotExpanded">
        {{ mapNotExpanded ? 'Expand map' : 'Collapse map' }}
    </button>
</div>
<agm-map #gm [ngClass]="mapNotExpanded ? 'not-fullheight' : ''" [latitude]="lat" [longitude]="lng" [zoom]="zoom" [usePanning]="true">
    <agm-marker
        *ngFor="let marker of drivers | arrayFilter: selectedDrivers; trackBy: trackByFn; let i = index"
        (markerClick)="clickedMarker(marker.shipment_id);"
        [latitude]="marker.geo_lat"
        [longitude]="marker.geo_lon"

        [iconUrl]="{
            url: 'https://dispatcher-api.astor.ua/mixer_image?number=' + marker.num + '&eta=' + marker.eta_time,
            scaledSize: {
                width: 40,
                height: 68
            }
        }">
        <agm-info-window>
            <table>
                <thead>
                    <tr>
                        <th colspan="2">#{{marker.shipment_id}} ({{ marker.request_id }})</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div class="title">Volume</div>
                            <div class="text"><strong> {{ marker.volume }} м<sup>3</sup> </strong></div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="title">Till object</div>
                            <div class="text"><strong> {{ marker.eta_distance }} kм.</strong></div>
                        </td>
                        <td>
                            <div class="title">Arrival to the object</div>
                            <div class="text"><strong> {{ marker.eta_calc_date | slice:0:10 }} </strong>&nbsp;<strong> {{ marker.eta_calc_time | slice:11:16 }} </strong></div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="title">Product on way</div>
                            <div class="text"><strong> {{ marker.product_time | time }} </strong></div>
                        </td>
                        <td>
                            <div class="title">Product on object</div>
                            <div class="text"><strong> {{ marker.product_eta | time }} </strong></div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="title">Driver</div>
                            <div class="text driver"><strong> {{ marker.driver_name }} </strong></div>
                            <div class="text"><strong><a href="tel:{{ marker.driver_phone }}"> {{ marker.driver_phone }} </a></strong></div>
                        </td>
                        <td>
                            <div class="title">Car</div>
                            <div class="text"><strong> {{ marker.vehicle_info }} </strong></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </agm-info-window>
    </agm-marker>
    <agm-marker
        *ngFor="let clientAddress of drivers | arrayFilter: selectedAddress; trackBy: trackByFn; let i = index"
        [latitude]="clientAddress.address_geo_lat"
        [longitude]="clientAddress.address_geo_lon"
        [iconUrl]="{
            url: './assets/img/object.png',
            scaledSize: {
                width: 40,
                height: 45
            }
        }"
        >
    </agm-marker>
    <agm-marker
        [latitude]="50.355781"
        [longitude]="30.555776"
        [iconUrl]="{
            url: './assets/img/factory.png',
            scaledSize: {
                width: 40,
                height: 45
            }
        }">
    </agm-marker>
    <agm-marker
      [latitude]="50.415451"
      [longitude]="30.417452"
      [iconUrl]="{
              url: './assets/img/factory.png',
              scaledSize: {
                  width: 40,
                  height: 45
              }
          }">
    </agm-marker>
    <agm-marker
        [latitude]="50.422633"
        [longitude]="30.702723"
        [iconUrl]="{
            url: './assets/img/factory.png',
            scaledSize: {
                width: 40,
                height: 45
            }
        }">
    </agm-marker>
    <agm-marker
        [latitude]="50.535076"
        [longitude]="30.233855"
        [iconUrl]="{
            url: './assets/img/factory.png',
            scaledSize: {
                width: 40,
                height: 45
            }
        }">
    </agm-marker>
    <agm-marker
        [latitude]="50.500510"
        [longitude]="30.482170"
        [iconUrl]="{
            url: './assets/img/factory.png',
            scaledSize: {
                width: 40,
                height: 45
            }
        }">
    </agm-marker>
    <!-- <agm-direction 
        [origin]="origin" 
        [destination]="destination"
        [transitOptions]="transitOptions">
    </agm-direction> -->
</agm-map>
